<template>
    <div class="w-100">
        <b-row class="pt-3">
            <b-col lg="5">
                <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    :placeholder="$i18n.locale()=='kz' ? 'Іздеу' : 'Поиск'"
                ></b-form-input>
            </b-col>
            <b-col lg="4">
                <select required id="fType" 
                    class="form-control" 
                    v-model="choosenfType" @change="sysChange()">
                    <option value="">
                        {{ $i18n.locale()=='kz' ? 'Таңдаңыз...' : 'Выберите...' }}
                    </option>
                    <option v-for="con in fTypes" :value="con.key">
                        {{con.value}}
                    </option>
                </select>
            </b-col>
            <b-col lg="3" class="pt-3 text-right">
                <strong>
                    {{$i18n.locale()=='kz' ? 'Жалпы саны:' : 'Общее число'}}
                </strong> {{totalRows}}  
            </b-col>
            <b-col lg="12">
                <b-table 
                    
                    ref="fileTable"
                    striped hover selectable
                    :items="projectFileProvider" 
                    :fields="fields"
                    :busy.sync="isBusy"
                    :current-page="currentPage"
                    :per-page="perPage"
                    table-variant='light'
                    :filter="filter"
                    :select-mode="selectMode"
                    responsive
                    
                    @row-selected="onRecordSelected"
                    >
                    <template v-slot:cell(ID)="{ rowSelected }">
                    <template v-if="rowSelected">
                        <span aria-hidden="true">&check;</span>
                        <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        <span class="sr-only">Not selected</span>
                    </template>
                    </template>
                    <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Жүктелуде...</strong>
                    </div>
                    </template>     
              
                    
                
                    <template v-slot:cell(actions)="row">
                        <b-button  @click="downLoadFile(row.item.fileId)"
                            class="mr-1"
                            variant="outline-success"  size="sm">
                            {{$t("project.downloadFile")}}
                        </b-button>
                        <b-button  @click="deleteProjectFile(row.item.fileId)"
                            variant="outline-danger"  size="sm">
                            {{$t("project.delFile")}}
                        </b-button>
                    </template>
                </b-table>
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="my-0"
                ></b-pagination>
            </b-col>
        </b-row>
        
    </div>
</template>
<script>
    import axios from 'axios';
    import {apiDomain,getHeader,getMultipartHeader,getDownloadHeader} from "@/config/config";
    import vue from 'vue';
    export default{
        name:"ProjectFileList",
        props:["pId"],
        data(){
            return {
                fTypes:[
                    // 'contract', 'exam', 'act','gurantee'
                    {
                        key:"contract",
                        value:"Договор"
                    },
                    {
                        key:"exam",
                        value:"Заключение госэкспернтизы"
                    },
                    {
                        key:"act",
                        value:"Акт выполненных работ"
                    },
                    {
                        key:"gurantee",
                        value:"Гарантинное письмо"
                    }
                ],
                fields: [
                    {
                        key: 'fileId',
                        label: 'ID',
                    },
                    {
                        key:"fType",
                        label: vue.i18n.translate('fForm.fType')
                    },
                    {
                        key: 'fDesc',
                        label: vue.i18n.translate('fForm.desc')
                    },
                    {
                        key: 'fKm',
                        label: vue.i18n.translate('fForm.km')
                    },
                    {
                        key:"endDate",
                        label: vue.i18n.translate('dpad.dForm.endDate')
                    },
                    {
                        key:"actions",
                        label:  vue.i18n.translate('project.file.actions'),
                    }
                
                ],
                isBusy:false,
                totalRows:0,
                currentPage: 1,
                perPage: 20,
                tableVariant:'light',
                filter:"",
                selectMode:'single',
                selectedRows:[],
                choosenfType:""
            }
        },
        methods:{
            sysChange(){
                
                this.$refs.fileTable.refresh();  
            }, 
            onRecordSelected(items){
                this.selectedRows=items;
            },
            deleteProjectFile(fileId){
                if(confirm(this.$t("project.delFileConfirm"))){
                    axios.post(apiDomain+'/p/deleteprojectfile',{"fileId":fileId},{headers:getHeader()})
                    .then(()=>{
                        this.$refs.fileTable.refresh();
                    }).catch(error => {
                        alert(error.message);
                    })
                }
            },
            downLoadFile(fileId){
                axios.post(apiDomain+'/p/downloadprojectfile',{"fileId":fileId},{responseType: "blob",headers:getHeader()})
                .then((response)=>{
                    // Get the content type from the response headers
                    const contentType = response.headers['content-type'];
                    
                    // Define a mapping of common content types to file extensions
                    const contentTypeToExtension = {
                        'application/pdf': 'pdf',
                        'application/zip': 'zip',
                        'application/rar': 'rar',
                        'image/jpeg': 'jpg',
                        'image/png': 'png',
                        'image/jpg': 'jpg',
                        'image/gif': 'gif',
                        'application/msword': 'doc',
                        'application/vnd.ms-excel': 'xls',
                        'application/vnd.ms-powerpoint': 'ppt',
                        'message/rfc822': 'msg',
                        'application/msaccess': 'mdb',
                        'application/vnd.ms-publisher': 'pub',
                        'application/vnd.visio': 'vsd',
                        'application/onenote': 'one',
                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
                        'application/json': 'json',
                    };
                    const defaultExtension = ''; 
                    const extension = contentTypeToExtension[contentType] || defaultExtension;
                    const href = URL.createObjectURL(response.data);
                    const link = document.createElement('a');
                    link.href = href;
                    link.setAttribute('download', `File-${fileId}.${extension}`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(href);
                    
                }).catch(error => {
                    alert(error.message);
                })
            },
            projectFileProvider(ctx){
                ctx.pId=this.pId
                this.isBusy = false
                ctx.projectType=this.choosenfType
                let promise = axios.post(apiDomain+'/p/listprojectfile',ctx,{headers:getHeader()});
                    return promise.then((response) => {
                    const result = response.data;
                    this.isBusy = false
                    this.totalRows=result.recordCount;
                    
                    return(result.items)
                }).catch(error => {
                    this.isBusy = false
                    return []
                })
            },
        }
    }
</script>